import React from 'react';
import { useSelector } from 'react-redux';

import CompanyInfo from './CompanyInfo';
import KeyContacts from './KeyContacts';
import Skeletons from '../Skeletons';

import { companyInfoSelector, companyInfoSettingsSelector, generalSelector } from '../../selectors';
import { initParams } from '../../configs';

const { permissions } = initParams;

const CompanyContacts = () => {
  const data = useSelector(companyInfoSelector);
  const { loaded, pending } = useSelector(companyInfoSettingsSelector);
  const general = useSelector(generalSelector);

  if (!permissions.allowContactInfo || permissions.isFlexUser) {
    return (
      <section className="publisher_page_company_contacts card p-a-lg">
        <div className="row w-100">
          <div className="col-6">
            <h3 className="text-md m-b-lg">Company Information</h3>
          </div>
          <div className="col-6">
            <h3 className="text-md m-b-lg">Key Contacts</h3>
          </div>
        </div>
        <div className="row">
          <div className="col-xxs-12 m-b-lg pos-rel">
            <p className="text-xxs-center text-xs center-y w-100 p-a">
              {permissions.isFlexUser ? (
                'Not included in your plan'
              ) : (
                <>
                  Company and key contact information is available&nbsp;
                  <a href="/pricing">on the Sales Prospector - Pro plan.</a>
                </>
              )}
            </p>
            <div
              className="publisher_page_company_contacts__blur"
              role="img"
              aria-label="Company Information and Key Contacts"
            />
          </div>
        </div>
      </section>
    );
  }

  if (pending || !loaded || !data) {
    return (
      <section className="publisher_page_company_contacts card p-a-lg">
        <div className="row">
          <div className="col-xxs-12 col-md-6 m-b-lg">{Skeletons.companyInfo}</div>
          <div className="col-xxs-12 col-md-6 m-b">{Skeletons.keyContacts}</div>
        </div>
      </section>
    );
  }

  return (
    <section className="publisher_page_company_contacts card p-a-lg">
      <div className="row">
        <div className="col-xxs-12 col-md-6 m-b-lg">
          <CompanyInfo company={data.company || {}} publisherName={general?.name} />
        </div>
        <div className="col-xxs-12 col-md-6 m-b">
          <KeyContacts contacts={data.keyContacts || []} />
        </div>
      </div>
    </section>
  );
};

export default CompanyContacts;
